import { Component, OnInit } from '@angular/core';
import { EquipoTecnologicoService } from 'src/app/pages/services/equipo-tecnologico.service';
import { EquipoTecnologico } from 'src/app/shared/models/equipo-tecnologico.interface';

@Component({
  selector: 'app-main-equipos-tecnologicos',
  templateUrl: './main-equipos-tecnologicos.component.html',
  styleUrls: ['./main-equipos-tecnologicos.component.css']
})
export class MainEquiposTecnologicosComponent implements OnInit {

  equipos: EquipoTecnologico[] = [];

  constructor(
    private equipoTecnologicoService: EquipoTecnologicoService
  ) { }

  ngOnInit(): void {
    this.equipoTecnologicoService.traerEquipos().subscribe(
      (res) => {
        this.equipos = res.data;
      });
  }

  actualizarTabla(event: boolean) {
    this.equipoTecnologicoService.traerEquipos().subscribe(res => {
      this.equipos = res.data;
    });
  }

}
